import { render, staticRenderFns } from "./artists.vue?vue&type=template&id=74293733&"
import script from "./artists.vue?vue&type=script&lang=js&"
export * from "./artists.vue?vue&type=script&lang=js&"
import style0 from "./artists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "artists.vue"
export default component.exports